<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title">Edit {{'pageHeader.userTargetRequestApprovalLevels' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p></p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div>
              <label class="control-label">{{'app.type' | translate}} </label>
              <input type="text"
                     name="name"
                     [(ngModel)]="selectedLevel.typeName"
                     #name="ngModel"
                     disabled
                     class="form-control" />
            </div>
          </div>


          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (user.dirty || user.touched || f.submitted)  && user.valid, 'has-error' : (user.dirty || user.touched || f.submitted)  && user.invalid}">
              <label class="control-label">{{'businessUnits.users' | translate}} </label>
              <ng-multiselect-dropdown placeholder="{{'businessUnits.users' | translate}}"
                                       [data]="users"
                                       name="user"
                                       #user="ngModel"
                                       [(ngModel)]="selectedLevel.users"
                                       [settings]="dropdownSettings"
                                       (onSelect)="onItemSelect($event)"
                                       (onSelectAll)="onSelectAll($event)">
              </ng-multiselect-dropdown>


              <div *ngIf="(user.dirty || user.touched || f.submitted)  && user.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
        
        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit">{{'app.save' | translate}}</button>

        </div>
      </form>
    </div>
  </div>

</div>
